import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_LoopingStatements = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Looping Statements in C"
    videos={[
      "https://www.youtube.com/embed/MCXUMxg4qIQ", // For Loop
      "https://www.youtube.com/embed/0tq4nA63F-Y", // While Loop
      "https://www.youtube.com/embed/I6WT2SVTqD8", // Do-While Loop
      "https://www.youtube.com/embed/LwcpOwbXlf8", // Break vs Continue
    ]}
    takeaways={[
      { text: "Remember the main difference between while and do-while loops." },
      { text: "While and For loops are entry-controlled; Do-while is exit-controlled." },
      { text: "In do-while loop, body executes at least once even if the condition is false." },
      { text: "Learn to convert between while loop and for loop." },
      { text: "Infinite loop declaration using: for(;;)." },
      { text: "Break and continue are loop control statements." },
      { text: "Understand flowcharts of all loop statements." },
      {
        text: "Loop Types:",
        points: [
          "For Loop → Count-controlled, Definite loop.",
          "While Loop → Pre-condition, Indefinite loop.",
          "Do-while Loop → Post-condition, Exit-controlled loop."
        ]
      },
      { text: "Differences between break and continue can be directly asked." },
      { text: "Expect questions on loop execution counts and outputs with break/continue." },
      { text: "Application-based questions like finding Prime Numbers or Odd/Even Numbers are possible." },
    ]}
    questions={[
      "Explain differences between for, while, and do-while loops.",
      "Write logic for finding prime numbers using loops.",
      "What is the difference between break and continue?",
      "Convert a while loop into an equivalent for loop.",
      "How many times will the loop run in a given code snippet?",
    ]}
    exampleVideos={[]} // Add if any examples are needed.
  />
);
}

export default OOPS_M1_LoopingStatements;
